<template v-if="attribute">
  <span>
    <label><input :disabled="isReadOnly" type="radio" v-model="attribute.ref.value" :value="true"> Ja</label>
    <label style="margin-left: 10px;"><input :disabled="isReadOnly" type="radio" v-model="attribute.ref.value" :value="false"> Nein</label>
  </span>
</template>

<script>

import Attribute from "../../xmlrdb-data/Attribute"
import ReadOnlyAnalyzer from "../../xmlrdb-metadata/ReadOnlyAnalyzer"
import formFieldVM from "./formFieldVM"

export default {
  name: "yesNoField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    readOnlyAnalyzer: {
      type: [ReadOnlyAnalyzer, Boolean],
      default: undefined
    },
  },
  setup(props){
     return formFieldVM(props);
  }
}

</script>

<style scoped lang="scss">
label {
  display: inline-block;
}
input {
  cursor: default !important;
}
</style>